<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.84082 8.68848H22.7402" stroke="black" stroke-miterlimit="10"/>
<path d="M8.84082 13.9609H22.7402" stroke="black" stroke-miterlimit="10"/>
<path d="M8.84082 19.2334H22.7402" stroke="black" stroke-miterlimit="10"/>
<path d="M5.25879 8.68848H6.73404" stroke="black" stroke-miterlimit="10"/>
<path d="M5.25879 14.0449H6.73404" stroke="black" stroke-miterlimit="10"/>
<path d="M5.25879 19.3115H6.73404" stroke="black" stroke-miterlimit="10"/>
</svg>
